// 配列操作。viewへの通知のため、インスタンスを作り直す
import * as Enumerable from "linq-es5"

export class ArrayHelper
{
    // クローンを作る
    public static clone<T>(array : Array<T>) : Array<T>
    {
        var cloned = new Array<T>();
        for(var i = 0; i < array.length; ++i)
        {
            cloned.push(array[i]);
        }
        return cloned;
    }

    // 値を追加して返す
    public static add<T>(array : Array<T>, item : T)
    {
        var cloned = this.clone(array);
        cloned.push(item);
        return cloned;
    }

    // 値を挿入して返す
    public static insert<T>(array : Array<T>, item : T, index : number)
    {
        var cloned = this.clone(array);
        cloned.splice(index, 0, item);
        return cloned;
    }

    // 値を削除して返す
    public static removeAt<T>(array : Array<T>, index : number)
    {
        var cloned = this.clone(array);
        cloned.splice(index, 1);
        return cloned;
    }

    public static remove<T>(array : Array<T>, item : T)
    {
        var cloned = new Array<T>();
        for(var i = 0; i < array.length; ++i)
        {
            if(array[i] != item)
            {
                cloned.push(array[i]);
            }
        }
        return cloned;
    }

    // 昇順に並び替える
    public static orderby<T>(array : Array<T>, keySelect : (T) => any)
    {
        var orderd = Enumerable.AsEnumerable(array).OrderBy(keySelect).ToArray();
        return orderd;
    }
}